export interface IFavorite {
    institution: string;
    type: string;
}

export class User {

    constructor(
        public $key: string,
        public userType: string,
        public firstName: string,
        public lastName: string,
        public address: string,
        public city: string,
        public prov: string,
        public country: string,
        public postalCode: string,
        public phoneHouse: string,
        public phoneMobile: string,
        public phoneWork: string,
        public PhoneExt: string,
        public email: string,
        public notifyBySms: boolean,
        public notifyByEmail: boolean,
        public notifyByPhone: boolean,
        public notifyByPush: boolean,
        public favoriteInstitution: IFavorite[]) {
    }

    static fromJsonList(array): User[] {
        return array.map(User.fromJson);
        // même chose: return array.map(json => Lesson.fromJson(json));
    }

    static fromJson({ $key, userType, firstName, lastName, address, city, prov, 
        country, postalCode, phoneHouse, phoneMobile, phoneWork, PhoneExt, email, 
        notifyBySms, notifyByEmail, notifyByPhone, notifyByPush, favoriteInstitution }): User {

        return new User(
            $key,
            userType,
            firstName,
            lastName,
            address,
            city,
            prov,
            country,
            postalCode,
            phoneHouse,
            phoneMobile,
            phoneWork,
            PhoneExt,
            email,
            notifyBySms,
            notifyByEmail,
            notifyByPhone,
            notifyByPush,
            favoriteInstitution
        )
    }
}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/model/user.ts